import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default {
    getTransactions(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('perioddiff'), 'getTransactions', [policyNumber], additionalHeaders);
    },

    compare(jobNumber1, jobNumber2, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('perioddiff'), 'compare', [jobNumber1, jobNumber2], additionalHeaders);
    },

    getDiffToPrevious(jobNumber, policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('perioddiff'), 'getDiffToPrevious', [jobNumber, policyNumber], additionalHeaders);
    },

    getDiffBetweenJobs(jobNumber1, jobNumber2, policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('perioddiff'), 'getDiffBetweenJobs', [jobNumber1, jobNumber2, policyNumber], additionalHeaders);
    },

    getDiffBetweenVersions(jobNumber, version1Index, version2Index, additionalHeaders = {}){
        return JsonRPCService.send(getProxiedServiceUrl('perioddiff'), 'getDiffBetweenVersions', [jobNumber, version1Index, version2Index], additionalHeaders);
    }
};
